module.exports = __webpack_public_path__ + "img/sym6.4fc3e765.png";